module.exports = __webpack_public_path__ + "assets/9355a2fe9a27e6fa5240283d22a82c3d.mp4";